
import { useParams } from "react-router-dom"
import url from "../api/url"
import { useEffect, useState } from "react"
import { elToast } from "../functions/Alerta"
import { useEmpleadoStore } from "../stores/useEmpleadoStore"
import { diferenciaEnDias, formatearFechaSpanish, sumarUnDia } from "../functions/formatearFecha"
import { Button } from "react-bootstrap"


export default function useVacacionesEmpleado() {

    const { id } = useParams();
    const objLogueado = useEmpleadoStore(state => state.objLogueado);
    const listaVacacionesEmpleado = useEmpleadoStore(state => state.listaVacacionesEmpleado);
    const setListaVacacionesEmpleado = useEmpleadoStore(state => state.setListaVacacionesEmpleado);
    const setEditarVacacionesEmpleado = useEmpleadoStore(state => state.setEditarVacacionesEmpleado);
    const setVacationsYear = useEmpleadoStore(state => state.setVacationsYear);
    const vacationsYear = useEmpleadoStore(state => state.vacationsYear);
    const [nombreEmpleado, setNombreEmpleado] = useState('');
    const setDiasVacaciones = useEmpleadoStore(state => state.setDiasVacaciones)
    const diasVacaciones = useEmpleadoStore(state => state.diasVacaciones)
    const [eventos, setEventos] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const { URL: URL_MIO } = url();
    const setDiasVacacionesSumados = useEmpleadoStore(state => state.setDiasVacacionesSumados)


    const traerNombreEmpleado = () => {

        if (!objLogueado.email) {
            return
        }


        fetch(URL_MIO, {
            method: 'post',
            body: JSON.stringify({ funcion: 'nombreEmpleadoPorId', id })
        })
            .then(res => res.json())
            .then(e => {
                setNombreEmpleado(e.nombre)
            })
            .catch(a => {
                // console.log(a);

                elToast('Hubo un error al obtener el nombre del empleado', 'error')
            })
    }


    // funciones del modal agregar vacaciones
    const handleCloseForm = () => {
        setShowForm(false);
        setEditarVacacionesEmpleado({})
    };
    const handleShowForm = () => {
        setShowForm(true)
    };

    const eliminarVacaciones = id => {

        if(!window.confirm('Seguro que deseas eliminar este registro?')) {
            return
        }

        fetch(URL_MIO, {
            method: 'post',
            body: JSON.stringify({
                funcion: 'eliminarVacaciones',
                id
            })
        })
        .then(res => res.json())
        .then(a => {
            if ( a.tipo === 1 ) {
                traerVacacionesVariables( id )
                elToast(a.mensaje)
            } else {
                elToast(a.mensaje, 'error')
            }
        })
        .catch(err => {
            // console.log(err)
            alert('Error al eliminar las vacaciones de este empleado')
        })
    }


    const traerVacacionesVariables = id => {
        const a = listaVacacionesEmpleado.filter(a => a.id !== id);
        let res = a.map(e => {
            return {
                title: 'Vacaciones',
                start: e.inicio,
                end: sumarUnDia(e.fin)
            }
        });
		let suma = 0;
		a.forEach(e => {
			suma += diferenciaEnDias(e.inicio, e.fin);
		});
		setDiasVacacionesSumados(suma);
        setEventos(res)
        setListaVacacionesEmpleado(a);
    }


    const handleDatesSet = (info) => {
        const year = new Date(info.start).getFullYear();
        if (year !== vacationsYear) {
            // console.log(`Cambio de año detectado: ${year}`);
            // setCurrentYear(year); // Actualiza el estado si el año cambia
            setVacationsYear(year);
            setDiasVacaciones(null)
        }
    };


    const cambiarDiasVacaciones = () => {

        if (diasVacaciones === false) {
            // insertar
            let dias = window.prompt('Ingrese la cantidad de dias de vacaciones');
            if (dias === null) {
                return
            }

            dias = Number( dias )
            if (!dias || dias < 1) {
                alert('Debes ingresar un número válido')
            } else {
                asignarDias( dias )
            }

        } else {
            // editar
            let dias = window.prompt('Ingrese la cantidad de dias de vacaciones', diasVacaciones || '');
            if (dias === null) {
                return
            }

            dias = Number( dias )
            if (!dias || dias < 1) {
                alert('Debes ingresar un número válido')
            } else {
                actualizarDias( dias )
            }
        }

    }

    const actualizarDias = dias => {

        fetch(URL_MIO, {
            method: 'post',
            body: JSON.stringify({
                funcion: 'editarDiasDeVacacionesEmpleado',
                id, // id del empleado
                dias,
                vacationsYear // año
            })
        })
        .then(res => res.json())
        .then(a => {
            if ( a.tipo === 1 ) {
                traerVacacionesVariables( id )
                setDiasVacaciones(dias)
                elToast(a.mensaje)
            } else {
                elToast(a.mensaje, 'error')
            }
        })
        .catch(err => {
            // console.log(err)
            alert('Error al actualizar los días de vacaciones de este empleado')
        })
    }

    const asignarDias = dias => {

        fetch(URL_MIO, {
            method: 'post',
            body: JSON.stringify({
                funcion: 'asignarDiasDeVacacionesEmpleado',
                id, // id del empleado
                dias,
                vacationsYear // año
            })
        })
        .then(res => res.json())
        .then(a => {
            if ( a.tipo === 1 ) {
                traerVacacionesVariables( id )
                setDiasVacaciones(dias)
                elToast(a.mensaje)
            } else {
                elToast(a.mensaje, 'error')
            }
        })
        .catch(err => {
            // console.log(err)
            alert('Error al asignar los días de vacaciones de este empleado')
        })
    }


    useEffect(() => {
        if (id) {
            traerNombreEmpleado()
        }

        // cuando salen de la pantalla
        return () => {
            setListaVacacionesEmpleado([])
            setDiasVacaciones(null)
        }

        // eslint-disable-next-line
    }, [])


    useEffect(() => {

        if (listaVacacionesEmpleado.length > 0) {
            let res = listaVacacionesEmpleado.map(e => {
                return {
                    title: 'Vacaciones',
                    start: e.inicio,
                    end: sumarUnDia(e.fin)
                }
            });
            setEventos(res)
        }
        // eslint-disable-next-line
    }, [listaVacacionesEmpleado])


    // tabla
    const columns = [
        {
            name: 'Fecha de inicio',
            sortable: true,
            selector: row => row.inicio,
            cell: row => formatearFechaSpanish(row.inicio, false)
        },
        {
            name: 'Fecha de fin',
            sortable: true,
            selector: row => row.fin,
            cell: row => formatearFechaSpanish(row.fin, false)
        },
        {
            name: 'Cantidad de días',
            sortable: true,
            center: "true",
            selector: row => row.fin,
            cell: row => diferenciaEnDias(row.inicio, row.fin)
        },
        {
            name: 'Opciones',
            selector: row => row.id,
            cell: row => (
                <>
                    <Button size="sm" variant="warning" onClick={() => {
                        handleShowForm();
                        // console.log(row);
                        setEditarVacacionesEmpleado(row);
                    }}>
                        Editar
                    </Button>
                    &nbsp;
                    <Button variant="danger" size="sm" onClick={() => eliminarVacaciones(row.id)}>
                        Eliminar
                    </Button>
                </>
            )
        },
    ];


    // calendario



    return {
        nombreEmpleado, eventos, columns,
        // multi inputs
        handleCloseForm, showForm, handleShowForm, handleDatesSet,
        cambiarDiasVacaciones
    }
}
